import { SxProps, Theme } from '@mui/material';

export const exportModalStyles: SxProps<Theme> = {
  maxWidth: 'sm',
  width: '100%',
};

export const exportTypeContainerStyles: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  mb: 3,
};

export const exportTypeCardStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  p: 2,
  border: '1px solid #e0e0e0',
  borderRadius: 1,
  '&:hover': {
    backgroundColor: '#f5f5f5',
  },
};

export const exportTypeContentStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
};

export const exportHistoryListStyles: SxProps<Theme> = {
  maxHeight: 200,
  overflow: 'auto',
  border: '1px solid #e0e0e0',
  borderRadius: 1,
  backgroundColor: '#fafafa',
  '&::-webkit-scrollbar': {
    width: '6px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: '#f1f1f1',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#c1c1c1',
    borderRadius: '3px',
    '&:hover': {
      backgroundColor: '#a1a1a1',
    },
  },
};

export const exportHistoryItemStyles: SxProps<Theme> = {
  py: 0.5,
  px: 2,
};

export const exportJobIconStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  mr: 2,
};

export const exportJobActionsStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
};
